import { Injectable } from '@angular/core';
import { CredentialsType } from '../../types/security/credentials.type';

@Injectable()
export class SecurityMapper {

    mapCredentialsToOauthFormat(credentials: CredentialsType): any {
        const result = {};
        result['username'] = credentials.username;
        result['password'] = credentials.password;
        result['client_id'] = credentials.clientId;
        result['grant_type'] = credentials.grantType;
        result['refresh_token'] = credentials.refreshToken;

        return result;
    }
}
